/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { SmallBadge } from "../../../../components/SmallBadge";
import { colors } from "../../../../components/colors";
import { StyledText } from "../../../../assets/typography/typography";

type Props = {
  status: "enabled" | "disabled" | "expired";
};

export const EnabledBadge = ({ status }: Props) => {
  const badgeAdditionalStyles = css`
    color: ${status === "enabled"
      ? colors.successDark
      : status === "disabled"
      ? colors.errorDark
      : colors.organgeDark};
  `;

  return (
    <SmallBadge
      additionalStyles={badgeAdditionalStyles}
      backgroundColor={
        status === "enabled"
          ? colors.successLight
          : status === "disabled"
          ? colors.errorLight
          : colors.orangeLight
      }
      borderColor={
        status === "enabled"
          ? colors.successMedium
          : status === "disabled"
          ? colors.errorMedium
          : colors.orangeMedium
      }
    >
      <StyledText className="bodyTextRegular mb-0">
        {status === "enabled"
          ? "Enabled"
          : status === "disabled"
          ? "Disabled"
          : "Expired"}
      </StyledText>
    </SmallBadge>
  );
};
